<div class="h-full flex flex-col">

  <!-- Back link -->
  <div 
    class="cursor-pointer mt-4 mb-6 shrink-0" 
    (click)="onBack()"
  >
    <span class="fa-icons icon-solid icon-angles-left icon-16 mr-2"></span>
    <span class="text-body-2 text-bush-green-140 font-semibold">
      {{ 'iqboost.buttons.backToMain' | translate }}
    </span>
  </div>

  <!-- Main container -->
  <div class="flex flex-col flex-1 w-full h-full border-0 rounded bg-neutral-5 p-4 min-h-0">

    <div class="flex shrink-0 pt-1 mb-5">
      <span class="maximizer-icons icon-iq-boost icon-24 pt-0.5 mr-3"></span>
      <h6>
        {{ 'iqboost.chat.askQuestions' | translate }}
      </h6>
    </div>

    <div 
      #scrollContainer
      class="flex-1 overflow-y-auto p-4 rounded min-h-0"
    >
      @for (chat of chatGroup()?.chatHistory; track $index) {
        <div class="flex flex-row space-y-2 mb-4">
          <div
            class="flex border rounded border-transparent p-4"
            [ngClass]="{
              'bg-bush-green-10': chat.from === IQChatFrom.User,
              'bg-neutral-5': chat.from === IQChatFrom.Ai,
            }"
          >
            @if (chat.from === IQChatFrom.User) {
              <span
                class="avatar avatar-xs mr-2 bg-inserv-10"
                [style.background-image]="(store.sessionInfo()?.user?.key ?? '') | avatar | async"
              >
                {{ (store.sessionInfo()?.user?.name ?? '') | nameInitials }}
              </span>
            }
            @else if (chat.from === IQChatFrom.Ai) {
              <span class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 mr-2 bg-inserv-10"></span>
            }
            <span class="text-body-2 text-black leading-7" [innerHTML]="chat.content | markdownRendering | clickableRef | entityKeyRef | deAnonymizer | webSearchRef | safeHtml"></span>
          </div>
        </div>
      }

      @if (streamingContent(); as streaming) {
        <div class="flex flex-row space-y-2 mb-4">
          <div class="flex border rounded border-transparent p-4 bg-neutral-5">
            <span class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 mr-2 bg-inserv-10"></span>
            <span class="text-body-2 text-black leading-7" [innerHTML]="streaming | markdownRendering | clickableRef | entityKeyRef | deAnonymizer | safeHtml"></span>
          </div>
        </div>
      }
      @else if (store.streamingStatusKey(); as statusKey) {
        <!-- Cursor-like phase status shown before the first token streams in -->
        <div class="flex flex-row space-y-2 mb-4">
          <div class="flex items-center border rounded border-transparent p-4 bg-neutral-5">
            <span class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 mr-2 bg-inserv-10"></span>
            <span class="text-body-2 text-bush-green-140 leading-7 animate-pulse pt-1 font-semibold">{{ statusKey | translate }}</span>
          </div>
        </div>
      }
    </div>

    <div class="flex w-full">
      <div class="flex w-3/4 items-center mx-auto">
        <div class="block w-full">
          <kendo-textbox
            #txtMakeQuestion
            class="block font-normal"
            [placeholder]="'iqboost.buttons.askQuestionNoPrompt.' + textVersion() + '.' + (store.useAllHouseholds() 
              ? (textVersion() === 'faVersion' ? 'allHouseholds' : 'allContacts') 
              : (textVersion() === 'faVersion' ? 'singleHousehold' : 'singleContact')) 
              | translate"
            [focusOnViewInit]="true"
            [clearButton]="false"
            (keydown.enter)="triggerQuestion(txtMakeQuestion);"
          >
          </kendo-textbox>
        </div>
        <button
          kendoButton
          themeColor="primary"
          class="h-8 ml-4 rounded-md"
          [disabled]="store.loading()"
          (click)="triggerQuestion(txtMakeQuestion);"
        >
          <div class="flex items-center">
            <span class="fa-icons icon-solid icon-16 icon-up"></span>
          </div>
        </button>
      </div>
    </div>
  </div>

</div>
